export default __webpack_public_path__ + "static/media/emergency-fuel.c3475203.svg";